import React from "react"
import PropTypes from "prop-types"
import styled, { ThemeProvider, createGlobalStyle } from "styled-components"
import Meta from "./meta"
import "./layout.css"

const theme = {
  black: "#000000",
  white: "#ffffff",
  grey: "#ebebeb",

  // media queries
  desktoplarge: "1800px",
  desktop: "1280px",
  tablet: "1021px",
  mobile: "750px",
  mobilesmall: "325px",
}

const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
        margin: 0;
    }

    html,
    body,
    #___gatsby,
    #gatsby-focus-wrapper,
    main {
      height: 100%;
      @media (max-width: ${theme.mobile}) {
          overflow: hidden;
        }
    }

    html {
        box-sizing: border-box;
        margin: 0;
        font-size: 10px;
        color: ${theme.black};
    }

    body {
        padding: 0;
        margin: 0;
        font-size: 1.4rem;
        line-height: 1;
        overflow-x: hidden;
        background: ${theme.black};
        font-family: 'Swiss721', Helvetica, sans-serif;
        text-transform: uppercase;
        font-weight: 600;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    ul,li,a,p,span,div{
      color: ${theme.white};
      margin: 0;
      padding: 0;
    }

    a {
        text-decoration: none;
    }

    a:hover {
        /* font-family: 'Swiss721Italic', Helvetica, sans-serif; */
    }

    ul {
      list-style-type: none;
    }

    li {
      margin-bottom: 1rem;
    }

    button {
      background:0;
      border:0;
      border-radius: 0;
      padding: 0;
      margin:0;
      appearance: none;
      color: ${theme.white};
      font-size: 1.4rem;
      line-height: 1;
      text-transform: uppercase;
      cursor: pointer;
    }

    .underline {
      text-decoration: underline;
    }

    .hover {
      &:hover {
      @media (min-width: ${theme.tablet}) {
        text-decoration: underline;
        }
      }
    }
    .underline.hover {
      &:hover {
      @media (min-width: ${theme.tablet}) {
        text-decoration: none;
        }
      }
    }

    .pointer {
      cursor: pointer;
    }
`

const Inner = styled.div`
  height: 100%;
  padding: 5rem 5rem 4rem;
  @media (max-width: ${theme.tablet}) {
    padding: 3rem 3rem 2rem;
    /* padding: 2.5rem 2.5rem 1.5rem; */
  }
`

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <Inner>
      <GlobalStyle />
      <Meta />
      <main>{children}</main>
    </Inner>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
